import { Product } from '../../types/product';

export const camaProducts: Product[] = [
  {
    id: "C001",
    name: "Jogo de Cama Solteiro 3 peças 180 Fios Supercal Turin",
    type: "product",
    category: "Cama",
    price: "R$ 65,00",
    description: "Jogo de cama solteiro com 180 fios, modelo Turin. Inclui 3 peças: 1 lençol com elástico, 1 lençol de cobrir e 1 fronha. Design elegante em xadrez nas cores bege, azul e caramelo.",
    imageUrl: "/lovable-uploads/c0427b76-6f55-4bec-9c6d-36f7a0a3740a.png",
    images: [
      "/lovable-uploads/c0427b76-6f55-4bec-9c6d-36f7a0a3740a.png",
      "/lovable-uploads/e2d02ef0-ffb8-4480-b3fe-2ed5f7d99d5d.png"
    ],
    isNew: true,
    colors: ["Bege", "Azul", "Caramelo"],
    features: [
      "180 fios de alta qualidade",
      "3 peças completas",
      "Tecido 100% algodão",
      "Design xadrez elegante",
      "Acabamento premium",
      "Durável e macio"
    ],
    keywords: ["cama", "jogo de cama", "solteiro", "turin", "180 fios", "xadrez"]
  },
  {
    id: "C002",
    name: "Jogo de Cama Solteiro 3 peças 180 Fios Supercal Flower Rosa",
    type: "product",
    category: "Cama",
    price: "R$ 65,00",
    description: "Jogo de cama solteiro com 180 fios, modelo Flower Rosa com estampa floral delicada. Inclui 3 peças: 1 lençol com elástico, 1 lençol de cobrir e 1 fronha. Design elegante em padrão floral com tons de rosa e verde em fundo claro.",
    imageUrl: "/lovable-uploads/845b8ccc-939c-45c4-9d91-42cf5e89698c.png",
    images: [
      "/lovable-uploads/845b8ccc-939c-45c4-9d91-42cf5e89698c.png",
      "/lovable-uploads/0ee3c72e-4e7c-42df-ae4b-0cf74e20a54c.png",
      "/lovable-uploads/3499147c-700f-4062-a450-98a221bde195.png"
    ],
    isNew: true,
    colors: ["Rosa", "Floral"],
    features: [
      "180 fios de alta qualidade",
      "3 peças completas",
      "Tecido 100% algodão",
      "Design floral elegante",
      "Acabamento premium",
      "Durável e macio"
    ],
    keywords: ["cama", "jogo de cama", "solteiro", "flower", "rosa", "180 fios", "floral"]
  },
  {
    id: "C003",
    name: "Jogo de Cama Solteiro 3 peças 180 Fios Supercal Spot Grid",
    type: "product",
    category: "Cama",
    price: "R$ 65,00",
    description: "Jogo de cama solteiro com 180 fios, modelo Spot Grid com elegante padrão geométrico. Inclui 3 peças: 1 lençol com elástico, 1 lençol de cobrir e 1 fronha. Design sofisticado em padrão xadrez entrecruzado em tons de bege e cinza.",
    imageUrl: "/lovable-uploads/1549a9ae-63bb-48fa-9050-0816dd805a4c.png",
    images: [
      "/lovable-uploads/1549a9ae-63bb-48fa-9050-0816dd805a4c.png",
      "/lovable-uploads/701928ab-02b0-45d8-912f-172f5876b57c.png",
      "/lovable-uploads/d8c6a6d1-5103-4786-86bb-0bacd11df6a6.png"
    ],
    isNew: true,
    colors: ["Bege", "Cinza"],
    features: [
      "180 fios de alta qualidade",
      "3 peças completas",
      "Tecido 100% algodão",
      "Design geométrico moderno",
      "Acabamento premium",
      "Durável e macio"
    ],
    keywords: ["cama", "jogo de cama", "solteiro", "spot grid", "180 fios", "geométrico"]
  },
  {
    id: "C004",
    name: "Jogo de Cama Solteiro 3 peças 180 Fios Supercal Brenno",
    type: "product",
    category: "Cama",
    price: "R$ 65,00",
    description: "Jogo de cama solteiro com 180 fios, modelo Brenno com padrão geométrico em tons de turquesa e bege. Inclui 3 peças: 1 lençol com elástico, 1 lençol de cobrir e 1 fronha. Design sofisticado com listras e padrões étnicos.",
    imageUrl: "/lovable-uploads/cc4ca3b8-68ac-4bd3-8f9b-8da566d45719.png",
    images: [
      "/lovable-uploads/cc4ca3b8-68ac-4bd3-8f9b-8da566d45719.png",
      "/lovable-uploads/0144cb13-c6ac-4443-a136-d1a72440f7af.png",
      "/lovable-uploads/8744a44a-8df8-46e6-874c-df98fe623b45.png"
    ],
    isNew: true,
    colors: ["Turquesa", "Bege"],
    features: [
      "180 fios de alta qualidade",
      "3 peças completas",
      "Tecido 100% algodão",
      "Design geométrico sofisticado",
      "Acabamento premium",
      "Durável e macio"
    ],
    keywords: ["cama", "jogo de cama", "solteiro", "brenno", "180 fios", "geométrico"]
  },
  {
    id: "C005",
    name: "Jogo de Cama Solteiro 3 peças 180 Fios Supercal British",
    type: "product",
    category: "Cama",
    price: "R$ 65,00",
    description: "Jogo de cama solteiro com 180 fios, modelo British. Inclui 3 peças para maior conforto.",
    imageUrl: "https://images.unsplash.com/photo-1649972904349-6e44c42644a7?q=80&w=500&auto=format&fit=crop",
    keywords: ["cama", "jogo de cama", "solteiro", "british", "180 fios"]
  },
  {
    id: "C006",
    name: "Protetor de Travesseiro",
    type: "product",
    category: "Cama",
    price: "R$ 12,00",
    description: "Protetor de travesseiro de alta qualidade para maior durabilidade e higiene.",
    imageUrl: "https://images.unsplash.com/photo-1721322800607-8c38375eef04?q=80&w=500&auto=format&fit=crop",
    keywords: ["cama", "protetor", "travesseiro", "higiene"]
  },
  {
    id: "C007",
    name: "Protetor de Colchão Comfort",
    type: "product",
    category: "Cama",
    price: "A partir de R$ 120,00",
    description: "Protetor de colchão linha Comfort, disponível em diversos tamanhos para maior proteção e conforto.",
    imageUrl: "https://images.unsplash.com/photo-1721322800607-8c38375eef04?q=80&w=500&auto=format&fit=crop",
    keywords: ["cama", "protetor", "colchão", "conforto", "comfort"]
  },
  {
    id: "C008",
    name: "Jogo de Cama Casal Priori Liso",
    type: "product",
    category: "Cama",
    price: "R$ 236,00",
    description: "Jogo de cama casal Priori Liso, com tecido macio e confortável para noites de sono tranquilas.",
    imageUrl: "https://images.unsplash.com/photo-1721322800607-8c38375eef04?q=80&w=500&auto=format&fit=crop",
    keywords: ["cama", "jogo de cama", "casal", "priori", "liso"]
  },
  {
    id: "C009",
    name: "Jogo de Cama Prisma 150 fios Estampado",
    type: "product",
    category: "Cama",
    price: "A partir de R$ 168,00",
    description: "Jogo de cama Prisma com 150 fios estampado, disponível em vários tamanhos e estampas.",
    imageUrl: "https://images.unsplash.com/photo-1649972904349-6e44c42644a7?q=80&w=500&auto=format&fit=crop",
    keywords: ["cama", "jogo de cama", "prisma", "150 fios", "estampado"]
  },
  {
    id: "C010",
    name: "Travesseiro Nasa Cervical",
    type: "product",
    category: "Cama",
    price: "R$ 194,00",
    description: "Travesseiro Nasa Cervical, ideal para quem busca um melhor alinhamento da coluna durante o sono.",
    imageUrl: "https://images.unsplash.com/photo-1721322800607-8c38375eef04?q=80&w=500&auto=format&fit=crop",
    keywords: ["cama", "travesseiro", "nasa", "cervical", "coluna"]
  },
  {
    id: "C011",
    name: "Travesseiro Percal 180 fios - Altemburg",
    type: "product",
    category: "Cama",
    price: "R$ 62,00",
    description: "Travesseiro Percal com 180 fios da Altemburg, macio e confortável para um sono tranquilo.",
    imageUrl: "https://images.unsplash.com/photo-1721322800607-8c38375eef04?q=80&w=500&auto=format&fit=crop",
    keywords: ["cama", "travesseiro", "percal", "180 fios", "altemburg"]
  },
  {
    id: "C012",
    name: "Travesseiro Bellagio - Altemburg",
    type: "product",
    category: "Cama",
    price: "R$ 24,99",
    description: "Travesseiro Bellagio da Altemburg, excelente custo-benefício para um sono de qualidade.",
    imageUrl: "https://images.unsplash.com/photo-1721322800607-8c38375eef04?q=80&w=500&auto=format&fit=crop",
    keywords: ["cama", "travesseiro", "bellagio", "altemburg"]
  },
  {
    id: "C013",
    name: "Travesseiro Antiestress - Altemburg",
    type: "product",
    category: "Cama",
    price: "R$ 98,90",
    description: "Travesseiro Antiestress da Altemburg, desenvolvido para proporcionar mais relaxamento durante o sono.",
    imageUrl: "https://images.unsplash.com/photo-1721322800607-8c38375eef04?q=80&w=500&auto=format&fit=crop",
    keywords: ["cama", "travesseiro", "antiestress", "altemburg", "relaxamento"]
  },
  {
    id: "C014",
    name: "Travesseiro 3D DaNasa - Duoflex",
    type: "product",
    category: "Cama",
    price: "R$ 92,00",
    description: "Travesseiro 3D DaNasa da Duoflex, com tecnologia que proporciona conforto e suporte durante o sono.",
    imageUrl: "https://images.unsplash.com/photo-1721322800607-8c38375eef04?q=80&w=500&auto=format&fit=crop",
    keywords: ["cama", "travesseiro", "3D", "DaNasa", "duoflex"]
  },
  {
    id: "C015",
    name: "Travesseiro Látex Light - Duoflex",
    type: "product",
    category: "Cama",
    price: "R$ 198,00",
    description: "Travesseiro Látex Light da Duoflex, leve e ergonômico para um melhor descanso.",
    imageUrl: "https://images.unsplash.com/photo-1721322800607-8c38375eef04?q=80&w=500&auto=format&fit=crop",
    keywords: ["cama", "travesseiro", "látex", "light", "duoflex"]
  },
  {
    id: "C016",
    name: "Travesseiro Altura Regulável - Duoflex",
    type: "product",
    category: "Cama",
    price: "R$ 210,00",
    description: "Travesseiro com Altura Regulável da Duoflex, adaptável às suas necessidades para melhor conforto.",
    imageUrl: "https://images.unsplash.com/photo-1721322800607-8c38375eef04?q=80&w=500&auto=format&fit=crop",
    keywords: ["cama", "travesseiro", "altura regulável", "duoflex"]
  },
  {
    id: "C017",
    name: "Travesseiro Fresh - Duoflex",
    type: "product",
    category: "Cama",
    price: "R$ 78,00",
    description: "Travesseiro Fresh da Duoflex, com tecnologia que proporciona sensação de frescor durante o sono.",
    imageUrl: "https://images.unsplash.com/photo-1721322800607-8c38375eef04?q=80&w=500&auto=format&fit=crop",
    keywords: ["cama", "travesseiro", "fresh", "duoflex", "frescor"]
  },
  {
    id: "C018",
    name: "Travesseiro Látex Light Alto - Duoflex",
    type: "product",
    category: "Cama",
    price: "R$ 230,00",
    description: "Travesseiro Látex Light Alto da Duoflex, para quem prefere travesseiros mais altos e confortáveis.",
    imageUrl: "https://images.unsplash.com/photo-1721322800607-8c38375eef04?q=80&w=500&auto=format&fit=crop",
    keywords: ["cama", "travesseiro", "látex", "light", "alto", "duoflex"]
  },
  {
    id: "C019",
    name: "Travesseiro Nasa Alto Premium - Duoflex",
    type: "product",
    category: "Cama",
    price: "R$ 260,00",
    description: "Travesseiro Nasa Alto Premium da Duoflex, com espuma viscoelástica de alta qualidade.",
    imageUrl: "https://images.unsplash.com/photo-1721322800607-8c38375eef04?q=80&w=500&auto=format&fit=crop",
    keywords: ["cama", "travesseiro", "nasa", "alto", "premium", "duoflex"]
  },
  {
    id: "C020",
    name: "Travesseiro Nasa Viscoelástico - Duoflex",
    type: "product",
    category: "Cama",
    price: "R$ 146,00",
    description: "Travesseiro Nasa Viscoelástico da Duoflex, com espuma que se adapta ao formato da cabeça e pescoço.",
    imageUrl: "https://images.unsplash.com/photo-1721322800607-8c38375eef04?q=80&w=500&auto=format&fit=crop",
    keywords: ["cama", "travesseiro", "nasa", "viscoelástico", "duoflex"]
  },
  {
    id: "C021",
    name: "Travesseiro toque de pluma toque macio 400 fios - Lavive",
    type: "product",
    category: "Cama",
    price: "R$ 89,00",
    description: "Travesseiro com toque de pluma e 400 fios da Lavive, super macio para um sono confortável.",
    imageUrl: "https://images.unsplash.com/photo-1721322800607-8c38375eef04?q=80&w=500&auto=format&fit=crop",
    keywords: ["cama", "travesseiro", "pluma", "400 fios", "lavive"]
  },
  {
    id: "C022",
    name: "Capa para almofada natalina",
    type: "product",
    category: "Cama",
    price: "R$ 25,00",
    description: "Capa para almofada com temática natalina, ideal para decorar sua casa nas festas de fim de ano.",
    imageUrl: "https://images.unsplash.com/photo-1721322800607-8c38375eef04?q=80&w=500&auto=format&fit=crop",
    keywords: ["cama", "capa", "almofada", "natalina", "decoração"]
  },
  {
    id: "C023",
    name: "Jogo de Cama Queen 4 peças 180 Fios Supercal Turin",
    type: "product",
    category: "Cama",
    price: "R$ 86,00",
    description: "Jogo de cama Queen com 180 fios, modelo Turin. Inclui 4 peças para maior conforto.",
    imageUrl: "https://images.unsplash.com/photo-1649972904349-6e44c42644a7?q=80&w=500&auto=format&fit=crop",
    keywords: ["cama", "jogo de cama", "queen", "turin", "180 fios"]
  },
  {
    id: "C024",
    name: "Jogo de Cama Queen 4 peças 180 Fios Supercal Spot Grid",
    type: "product",
    category: "Cama",
    price: "R$ 86,00",
    description: "Jogo de cama Queen com 180 fios, modelo Spot Grid. Inclui 4 peças para maior conforto.",
    imageUrl: "https://images.unsplash.com/photo-1649972904349-6e44c42644a7?q=80&w=500&auto=format&fit=crop",
    keywords: ["cama", "jogo de cama", "queen", "spot grid", "180 fios"]
  },
  {
    id: "C025",
    name: "Jogo de Cama Queen 4 peças 180 Fios Supercal Flower Rosa",
    type: "product",
    category: "Cama",
    price: "R$ 86,00",
    description: "Jogo de cama Queen com 180 fios, modelo Flower Rosa. Inclui 4 peças para maior conforto.",
    imageUrl: "https://images.unsplash.com/photo-1649972904349-6e44c42644a7?q=80&w=500&auto=format&fit=crop",
    keywords: ["cama", "jogo de cama", "queen", "flower", "rosa", "180 fios"]
  },
  {
    id: "C026",
    name: "Jogo de Cama Queen 4 peças 180 Fios Supercal Brenno",
    type: "product",
    category: "Cama",
    price: "R$ 86,00",
    description: "Jogo de cama Queen com 180 fios, modelo Brenno. Inclui 4 peças para maior conforto.",
    imageUrl: "https://images.unsplash.com/photo-1649972904349-6e44c42644a7?q=80&w=500&auto=format&fit=crop",
    keywords: ["cama", "jogo de cama", "queen", "brenno", "180 fios"]
  },
  {
    id: "C027",
    name: "Jogo de Cama Queen 4 peças 180 Fios Supercal British",
    type: "product",
    category: "Cama",
    price: "R$ 86,00",
    description: "Jogo de cama Queen com 180 fios, modelo British. Inclui 4 peças para maior conforto.",
    imageUrl: "https://images.unsplash.com/photo-1649972904349-6e44c42644a7?q=80&w=500&auto=format&fit=crop",
    keywords: ["cama", "jogo de cama", "queen", "british", "180 fios"]
  },
  {
    id: "C028",
    name: "Jogo de Cama Casal 4 peças 180 Fios Supercal Flower Rosa",
    type: "product",
    category: "Cama",
    price: "R$ 78,00",
    description: "Jogo de cama Casal com 180 fios, modelo Flower Rosa. Inclui 4 peças para maior conforto.",
    imageUrl: "https://images.unsplash.com/photo-1649972904349-6e44c42644a7?q=80&w=500&auto=format&fit=crop",
    keywords: ["cama", "jogo de cama", "casal", "flower", "rosa", "180 fios"]
  },
  {
    id: "C029",
    name: "Jogo de Cama Casal 4 peças 180 Fios Supercal Turin",
    type: "product",
    category: "Cama",
    price: "R$ 78,00",
    description: "Jogo de cama Casal com 180 fios, modelo Turin. Inclui 4 peças para maior conforto.",
    imageUrl: "https://images.unsplash.com/photo-1649972904349-6e44c42644a7?q=80&w=500&auto=format&fit=crop",
    keywords: ["cama", "jogo de cama", "casal", "turin", "180 fios"]
  },
  {
    id: "C030",
    name: "Jogo de Cama Casal 4 peças 180 Fios Supercal Spot Grid",
    type: "product",
    category: "Cama",
    price: "R$ 78,00",
    description: "Jogo de cama Casal com 180 fios, modelo Spot Grid. Inclui 4 peças para maior conforto.",
    imageUrl: "https://images.unsplash.com/photo-1649972904349-6e44c42644a7?q=80&w=500&auto=format&fit=crop",
    keywords: ["cama", "jogo de cama", "casal", "spot grid", "180 fios"]
  },
  {
    id: "C031",
    name: "Jogo de Cama Casal 4 peças 180 Fios Supercal Brenno",
    type: "product",
    category: "Cama",
    price: "R$ 78,00",
    description: "Jogo de cama Casal com 180 fios, modelo Brenno. Inclui 4 peças para maior conforto.",
    imageUrl: "https://images.unsplash.com/photo-1649972904349-6e44c42644a7?q=80&w=500&auto=format&fit=crop",
    keywords: ["cama", "jogo de cama", "casal", "brenno", "180 fios"]
  },
  {
    id: "C032",
    name: "Jogo de Cama Solteiro 3 peças 180 Fios Supercal Andreza Floral",
    type: "product",
    category: "Cama",
    price: "R$ 65,00",
    description: "Jogo de cama Solteiro com 180 fios, modelo Andreza Floral. Inclui 3 peças para maior conforto.",
    imageUrl: "https://images.unsplash.com/photo-1649972904349-6e44c42644a7?q=80&w=500&auto=format&fit=crop",
    keywords: ["cama", "jogo de cama", "solteiro", "andreza", "floral", "180 fios"]
  },
  {
    id: "C033",
    name: "Jogo de Cama Priori Estampado",
    type: "product",
    category: "Cama",
    price: "A partir de R$ 158,00",
    description: "Jogo de cama Priori Estampado, disponível em diversos tamanhos e estampas para seu quarto.",
    imageUrl: "https://images.unsplash.com/photo-1649972904349-6e44c42644a7?q=80&w=500&auto=format&fit=crop",
    keywords: ["cama", "jogo de cama", "priori", "estampado"]
  },
  {
    id: "C034",
    name: "Travesseiro Nasa Alto",
    type: "product",
    category: "Cama",
    price: "R$ 165,00",
    description: "Travesseiro Nasa Alto, com tecnologia viscoelástica que proporciona maior conforto e suporte.",
    imageUrl: "https://images.unsplash.com/photo-1721322800607-8c38375eef04?q=80&w=500&auto=format&fit=crop",
    keywords: ["cama", "travesseiro", "nasa", "alto"]
  },
  {
    id: "C035",
    name: "Travesseiro Sono e Saúde",
    type: "product",
    category: "Cama",
    price: "R$ 88,00",
    description: "Travesseiro Sono e Saúde, desenvolvido para proporcionar uma melhor qualidade de sono.",
    imageUrl: "https://images.unsplash.com/photo-1721322800607-8c38375eef04?q=80&w=500&auto=format&fit=crop",
    keywords: ["cama", "travesseiro", "sono", "saúde"]
  }
];
